import occInstance from '@/api/instances/occ.js';

const NavApi = {
  async getNavDataByNodeID({userId, componentId, b2bUnitId, b2bUserRoles}) {
    const response = await occInstance.get(`/users/${userId}/cms/components/${componentId}/navigation`, {
      params: {
        ...(b2bUnitId ? {b2bUnitId} : {}),
        ...(b2bUserRoles ? {b2bUserRoles} : {}),
      },
    });
    return response.data.navigationNodes;
  },
};

export default NavApi;
